import newRegime from "./taxSlab/newTaxRegime.json";
import oldRegime from "./taxSlab/oldTaxRegime.json";

export const getDeviceType = () => {
  const ua = navigator.userAgent;

  if (/mobile/i.test(ua)) {
    return "mobile";
  }

  if (/tablet|ipad|playbook|silk/i.test(ua)) {
    return "tablet";
  }

  if (/android|iphone|ipod/i.test(ua)) {
    return "mobile"; // extra fallback
  }

  return "desktop";
};

export const getImage = (imageName, type) => {
  if (imageName == "extention_logo") {
    switch (type ? type.toLowerCase() : type) {
      case "xls":
      case "xlsx":
      case "csv":
        imageName = "excel_logo.png";
        break;
      case "doc":
      case "docx":
        imageName = "word_logo.png";
        break;
      case "gif":
      case "png":
      case "jpg":
      case "jpeg":
      case "webp":
      case "svg":
      case "ico":
      case "tiff":
        imageName = "img_logo.png";
        break;
      case "pdf":
        imageName = "pdf_logo.png";
        break;
      case "mp3":
      case "wav":
        imageName = "audio_logo.png";
        break;
      case "mp4":
      case "avi":
      case "mov":
      case "wmv":
      case "webm":
        imageName = "video_logo.png";
        break;
      default:
        imageName = "doc_logo.png";
        break;
    }
  }
  try {
    if (imageName && imageName !== "") {
      return require(`../../assets/${imageName}`);
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const getAssessmentYear = (financialYear) => {
  // Split FY by "-"
  const [start, end] = financialYear.split("-").map(Number);
  // Add 1 year to each part
  const AYStart = start + 1;
  const AYEnd = end + 1;
  return `${AYStart}-${AYEnd}`;
};

export const addMonthNumberAndSort = (data, monthField = "mn") => {
  const monthMap = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12,
  };

  // Step 1: add mnno field
  const updated = data.map((item) => ({
    ...item,
    mnno: monthMap[item[monthField]] || 0,
  }));

  // Step 2: sort by mnno
  updated.sort((a, b) => a.mnno - b.mnno);

  return updated;
};

export function calculateTaxFromJSON(salary, year) {
  const config = newRegime[year];

  if (!config) {
    throw new Error(`Tax slab not found for year ${year}`);
  }

  const slabs = config.slabs;

  let remainingIncome = salary;
  let previousLimit = 0;
  let totalTax = 0;

  for (const slab of slabs) {
    if (remainingIncome <= 0) break;

    const upperLimit = slab.upto ?? Infinity;
    const slabRange = upperLimit - previousLimit;
    const taxableAmount = Math.min(remainingIncome, slabRange);

    totalTax += taxableAmount * slab.rate;

    remainingIncome -= taxableAmount;
    previousLimit = upperLimit;
  }

  return Math.round(totalTax);
}

// export function calculateOldRegimeTax(salary, year, category) {
//   console.log("salary", salary, year, category);
//   const yearConfig = oldRegime[year];
//   console.log("yearConfig", yearConfig);
//   if (!yearConfig) {
//     throw new Error(`Tax slab not found for year ${year}`);
//   }

//   const categoryConfig = yearConfig[category];

//   if (!categoryConfig) {
//     throw new Error(`Tax slab not found for category ${category}`);
//   }

//   const slabs = categoryConfig.slabs;

//   let remainingIncome = salary;
//   let previousLimit = 0;
//   let totalTax = 0;

//   for (const slab of slabs) {
//     if (remainingIncome <= 0) break;

//     const upperLimit = slab.upto ?? Infinity;
//     const slabRange = upperLimit - previousLimit;
//     const taxableAmount = Math.min(remainingIncome, slabRange);

//     totalTax += taxableAmount * slab.rate;

//     remainingIncome -= taxableAmount;
//     previousLimit = upperLimit;
//   }

//   return Math.round(totalTax);
// }

export function calculateOldRegimeTax(
  salary,
  year,
  gender, // "male" | "female"
  ageCategory, // "below60" | "senior" | "superSenior"
) {
  console.log("salary", salary, year, gender, ageCategory);

  const yearConfig = oldRegime[year];
  if (!yearConfig) {
    throw new Error(`Tax slab not found for year ${year}`);
  }

  console.log("yearconfig", gender, yearConfig);

  const genderConfig = yearConfig[gender];
  if (!genderConfig) {
    throw new Error(`Tax slab not found for gender ${gender}`);
  }

  const categoryConfig = genderConfig[ageCategory];
  if (!categoryConfig) {
    throw new Error(`Tax slab not found for ${gender} - ${ageCategory}`);
  }

  console.log("categoryConfig", categoryConfig);

  const slabs = categoryConfig.slabs;

  let remainingIncome = salary;
  let previousLimit = 0;
  let totalTax = 0;

  for (const slab of slabs) {
    if (remainingIncome <= 0) break;

    const upperLimit = slab.upto ?? Infinity;
    const slabRange = upperLimit - previousLimit;
    const taxableAmount = Math.min(remainingIncome, slabRange);

    totalTax += taxableAmount * slab.rate;

    remainingIncome -= taxableAmount;
    previousLimit = upperLimit;
  }

  return Math.round(totalTax);
}

export function getAgeCategoryFromDOB(dob) {
  if (!dob) {
    return "below60";
  }

  const birthDate = new Date(dob);
  if (isNaN(birthDate.getTime())) {
    throw new Error("Invalid DOB format. Use YYYY-MM-DD");
  }

  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  // Adjust age if birthday hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  if (age >= 80) return "superSenior";
  if (age >= 60) return "senior";
  return "below60";
}
